import Vue from 'vue'

export const store = Vue.observable({
  assetsEndpoint: null,
  compassSettings: {},
})

export const mutations = {
  setAssetsEndpoint(endpoint) {
    store.assetsEndpoint = endpoint
  },
  fetchCompassSettingsForBuilding(buildingNumber, path) {
    if (store.compassSettings[buildingNumber] === null) return

    const req = new XMLHttpRequest()

    let response = null
    req.onreadystatechange = function () {
      if (this.readyState === this.DONE) {
        if (req.status === 200) {
          response = JSON.parse(req.responseText)
          store.compassSettings[buildingNumber] = response.FramesCompassData
        }
      } else {
        store.compassSettings[buildingNumber] = null
      }
    }

    const url = `${store.assetsEndpoint}${path}`
    req.open('GET', url, false)
    req.send()
  },
}
